import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(false);
  const code = searchParams.get('code');

  const handleVerify = async () => {
    if (!code) {
      toast.error('Invalid verification code');
      return;
    }

    try {
      setVerifying(true);
      await authAPI.verifyEmail(code);
      toast.success('Email verified successfully!');
      navigate('/wizard');
    } catch (error) {
      toast.error('Verification failed');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="wrapper">
      <div className="section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-lg-offset-3">
              <div className="well bg-white text-center">
                <h3>Verify Your Email</h3>
                <p className="text-muted">
                  Please verify your email address to continue using MatchUs.
                </p>
                <hr />
                {code ? (
                  <button
                    className="btn-primary btn-lg"
                    onClick={handleVerify}
                    disabled={verifying}
                  >
                    {verifying ? 'Verifying...' : 'Verify Email'}
                  </button>
                ) : (
                  <p className="text-danger">
                    Invalid or missing verification code. Please check your email.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;

